import { render, staticRenderFns } from "./firmwareManage.vue?vue&type=template&id=3bc6af5f&scoped=true"
import script from "./firmwareManage.vue?vue&type=script&lang=js"
export * from "./firmwareManage.vue?vue&type=script&lang=js"
import style0 from "./firmwareManage.vue?vue&type=style&index=0&id=3bc6af5f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc6af5f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bc6af5f')) {
      api.createRecord('3bc6af5f', component.options)
    } else {
      api.reload('3bc6af5f', component.options)
    }
    module.hot.accept("./firmwareManage.vue?vue&type=template&id=3bc6af5f&scoped=true", function () {
      api.rerender('3bc6af5f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/product-details/firmware/firmwareManage.vue"
export default component.exports